const timeDateFormat = 'hh:mm a MM/DD/YYYY';

export const dateTimeFormat = 'MM/DD/YYYY hh:mm a';

export default timeDateFormat;



// WEBPACK FOOTER //
// ./src/config/timeDateFormat.js